import React from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import VenueStorefrontContent from '../../platform/components/marketplace/VenueStorefrontContent';

const VenueMarketplaceHome = () => {
    return (
        <>
            <Header />
            <VenueStorefrontContent isPublic />
            <Footer />
        </>
    );
};

export default VenueMarketplaceHome;
